import React, { useRef } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { ConfirmPopup } from 'primereact/confirmpopup';

import {
  REACT_APP_ENABlE_ONLY_FOR_PF_USER,
  REACT_APP_ENABLE_PUSH_NOTIFICATION,
} from '../../../constants/envConstants';

import {
  getUserSettingTabs,
  // userSettingTabs,
} from './components/userSettingTabs';

const UserSettingsContainer = ({ defaultTabIndex, handleCloseDialogue }) => {
  const toast = useRef(null);
  const [activeTabIndex, setActiveTabIndex] = React.useState(defaultTabIndex);

  const isPFUser =
    JSON.parse(localStorage.getItem('isPFUser') ?? 'false') ?? false;
  const pushNotificationEnabled =
    REACT_APP_ENABlE_ONLY_FOR_PF_USER === false
      ? REACT_APP_ENABLE_PUSH_NOTIFICATION
      : isPFUser;

  const isMpinSet = localStorage?.getItem('is_mpin_enabled');

  const tabs = getUserSettingTabs(isMpinSet, pushNotificationEnabled);
  return (
    <>
      <ConfirmPopup />
      <div className="grid w-12 m-0">
        <div className="py-2 action-button-wrapper ">
          <div className="flex flex-row action-button-section justify-content-end gap-0"></div>
        </div>
      </div>

      <div className="flex flex-column w-full user-detail-form">
        <TabView
          activeIndex={activeTabIndex}
          onTabChange={e => setActiveTabIndex(e.index)}
          pt={{
            nav: {
              className: 'border-0',
            },
          }}
          className="pf-tab-view"
        >
          {tabs.map(tab => {
            if (!tab.isVisible) return null;
            const SettingTabComponent = tab.component;

            return (
              <TabPanel key={tab.header} header={tab.header}>
                {tab.header === 'Pin Setup' || tab.header === 'Reset Pin' ? (
                  <SettingTabComponent
                    handleCloseDialogue={handleCloseDialogue}
                  />
                ) : (
                  <SettingTabComponent />
                )}
              </TabPanel>
            );
          })}
        </TabView>
        <ConfirmDialog className="pf-confirm-dialog" />
      </div>

      <Toast ref={toast} />
    </>
  );
};

export default UserSettingsContainer;
